import { Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'

/**
 * Service to set the browser title.
 * Used to add the JMeleon prefix to the title.
 * Will stay active for centralized future title manipulations.
 */
@Injectable({
  providedIn: 'root'
})
export class JmlTitleService {
  private readonly TITLE_PREFIX = 'JMeleon - '

  constructor(private titleService: Title) {}

  setAppTitle(title: string): void {
    // const fullTitle = `${this.TITLE_PREFIX}${title}`;
    // console.log('setting browser title', title)
    this.titleService.setTitle(title)
  }
}
